import PropTypes from 'prop-types';
import React from 'react';

const TableTurnTypeCell = ({ turn_type }) => {
  let label;
  switch (turn_type) {
    case '1':
      label = 'Move In';
      break;
    case '2':
      label = 'Pre Move Out';
      break;
    case '3':
      label = 'Move Out';
      break;
    case '4':
      label = 'Make Ready';
      break;
    default:
      break;
  }

  return (
    <div className="TableTurnTypeCell">
      <span>{label}</span>
    </div>
  );
};

TableTurnTypeCell.propTypes = {
  turn_type: PropTypes.string.isRequired
}

export default TableTurnTypeCell;
